import { connect } from 'react-redux'
import Progress from '../components/Progress'


const mapStateToProps = (state) => {
	return {open: state.progress.open, message: state.progress.message};
}

const ProgressContainer = connect(
	mapStateToProps
)(Progress)

export default ProgressContainer


// WEBPACK FOOTER //
// ./src/containers/ProgressContainer.js